import { Card, CardContent } from "@/components/ui/card";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { SEOHead } from "@/components/SEOHead";

export default function Accessibility() {
  return (
    <div className="min-h-screen bg-background font-sans text-foreground flex flex-col">
      <SEOHead 
        title="Accessibility Statement | Woods Spine & Wellness"
        description="Our commitment to accessibility for all users at Woods Spine & Wellness."
        canonical="https://woodsspine.com/accessibility"
      />
      <Navbar />
      <main className="flex-grow">
        <section className="bg-primary py-16 text-primary-foreground text-center">
          <div className="container mx-auto px-4">
            <h1 className="text-4xl md:text-5xl font-bold mb-4">Accessibility Statement</h1>
            <p className="text-xl opacity-90">Our commitment to accessibility for all users.</p>
          </div>
        </section>

        <section className="py-16">
          <div className="container mx-auto px-4 max-w-4xl">
            <Card className="shadow-lg border-0">
              <CardContent className="p-8 md:p-12 prose prose-slate max-w-none">
                <p className="text-lg text-muted-foreground mb-8">
                  Woods Spine & Wellness is committed to ensuring digital accessibility for people with disabilities. We are continually improving the user experience for everyone and applying the relevant accessibility standards.
                </p>

                <h3 className="text-2xl font-bold text-primary mb-4">Measures to support accessibility</h3>
                <p className="mb-4">Woods Spine & Wellness takes the following measures to ensure accessibility of our website:</p>
                <ul className="list-disc pl-6 mb-6 space-y-1">
                  <li>Include accessibility throughout our internal policies.</li>
                  <li>Integrate accessibility into our procurement practices.</li>
                  <li>Provide continual accessibility training for our staff.</li>
                  <li>Assign clear accessibility targets and responsibilities.</li>
                </ul>

                <h3 className="text-2xl font-bold text-primary mb-4">Conformance status</h3>
                <p className="mb-4">
                  The Web Content Accessibility Guidelines (WCAG) defines requirements for designers and developers to improve accessibility for people with disabilities. It defines three levels of conformance: Level A, Level AA, and Level AAA. Our website is partially conformant with WCAG 2.1 level AA. Partially conformant means that some parts of the content do not fully conform to the accessibility standard.
                </p>

                <h3 className="text-2xl font-bold text-primary mb-4">Feedback</h3>
                <p className="mb-4">
                  We welcome your feedback on the accessibility of Woods Spine & Wellness. Please let us know if you encounter accessibility barriers on our website:
                </p>

                <div className="bg-muted p-6 rounded-lg mt-8">
                  <p className="font-bold mb-2">Woods Spine & Wellness</p>
                  <p className="mb-1"><strong>Phone:</strong> (903) 215-8828</p>
                  <p className="mb-1"><strong>E-mail:</strong> woodsspine.office@gmail.com</p>
                  <p><strong>Visitor Address:</strong> 530 E LOOP 281 STE 103, Longview, TX 75605</p>
                </div>
              </CardContent>
            </Card>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
